import { render, staticRenderFns } from "./ReporteSubOperaciones.vue?vue&type=template&id=ba90b194&"
import script from "./ReporteSubOperaciones.vue?vue&type=script&lang=js&"
export * from "./ReporteSubOperaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports